import { c as _c } from "react/compiler-runtime";
import { LayoutStack } from 'design-system/client';
import AmountSelection from './AmountSelection';
import IntervalSelection from './IntervalSelection';
function AmountAndIntervalSelection() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <LayoutStack space="400"><IntervalSelection /><AmountSelection /></LayoutStack>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export default AmountAndIntervalSelection;